module.exports = __webpack_public_path__ + "static/img/67-2.8581238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/67-2.jpg
// module id = ag9S
// module chunks = 0